import clsx from 'clsx';
import React from 'react';

import { createStyles } from "../BrowsingCard/styles";
import BrowsingCardName from "../common/BrowsingCardName";
import ProductRates from "../common/ProductRates";
import SponsorHeader from "../common/SponsorHeader";
















var BrowsingSingleProduct = function BrowsingSingleProduct(_ref)












{var product = _ref.product,portfolioId = _ref.portfolioId,marketingTags = _ref.marketingTags,marketingTagIds = _ref.marketingTagIds,isPortfolioInProposal = _ref.isPortfolioInProposal,isMultiProductPortfolio = _ref.isMultiProductPortfolio,showMobileLayoutVersion = _ref.showMobileLayoutVersion,createCompareCheckbox = _ref.createCompareCheckbox,createProductAttributesInfo = _ref.createProductAttributesInfo,createActionButtonWrapper = _ref.createActionButtonWrapper,createViewPlanDetailsButton = _ref.createViewPlanDetailsButton,className = _ref.className;
  var classes = createStyles({
    isPortfolioInProposal: isPortfolioInProposal,
    isMultiProductPortfolio: isMultiProductPortfolio,
    showMobileLayoutVersion: showMobileLayoutVersion
  });

  var imProductId = product.imProductId,carrier = product.carrier,productDisplayName = product.productDisplayName,bcDependentData = product.bcDependentData,productLine = product.productLine;

  // for browsingCard always should take object with key '0'. There can't be more than 1 bc
  var currentBcInfo = bcDependentData['0'];
  var productAttributes = currentBcInfo.productAttributes,rates = currentBcInfo.rates;

  return /*#__PURE__*/(
    React.createElement("div", { className: clsx(classes.cardWrapper, className), id: imProductId, key: imProductId }, /*#__PURE__*/

    React.createElement(SponsorHeader, {
      carrier: carrier,
      marketingTagIds: marketingTagIds,
      portfolioId: portfolioId,
      marketingTags: marketingTags,
      styles: showMobileLayoutVersion ? classes.mobileCardHeader : classes.cardHeader }), /*#__PURE__*/


    React.createElement("div", null, /*#__PURE__*/
    React.createElement(BrowsingCardName, {
      name: productDisplayName,
      wrapperStyles:
      showMobileLayoutVersion ? classes.mobileProductNameWrapper : classes.productNameWrapper,

      isPortfolioInProposal: isPortfolioInProposal }), /*#__PURE__*/

    React.createElement("div", { className: classes.actionSection }, /*#__PURE__*/

    React.createElement(ProductRates, { id: imProductId, rates: rates, styles: classes.ratesList }),
    createActionButtonWrapper(portfolioId))),



    createProductAttributesInfo(productAttributes, productLine), /*#__PURE__*/

    React.createElement("div", { className: classes.cardFooter },
    createCompareCheckbox(portfolioId),
    createViewPlanDetailsButton(portfolioId))));



};

export default BrowsingSingleProduct;
//# sourceMappingURL=index.js.map